import React, { FC }           from "react";
import { useDispatch }         from "react-redux";
import { Tab }                 from "semantic-ui-react";
import RouterDispatcher        from "../../../../infrastructure/redux/router/RouterDispatcher";
import BackHistoryButton       from "../../common/BuckHistoryButton";
import TopSection              from "../../common/layout/TopSection";
import CustomerRecordList      from "../record/CustomerRecordList";
import CustomerRecordNewButton from "./CustomerRecordNewButton";

const CustomerRecordsTab: FC = () => {
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  return (
    <>
      <Tab
        renderActiveOnly
        activeIndex={ 1 }
        onTabChange={ (event, data) => {
          if (data.activeIndex === 0) routerDispatcher.customerEdit();
        } }
        panes={ [
          {
            menuItem: "基本情報",
          },
          {
            menuItem: "記録情報",
            render: () => (
              <Tab.Pane>
                <TopSection>
                  <CustomerRecordNewButton/>
                  <BackHistoryButton path="/customers"/>
                </TopSection>
                <CustomerRecordList/>
              </Tab.Pane>
            )
          }
        ] }
      />
    </>
  );
};

export default CustomerRecordsTab;
